<template>
  <v-sheet :height="height ? height : h">
    <v-calendar
      ref="calendar"
      id="calendar"
      :class="{ cursor: disabled }"
      v-model="value"
      color="primary"
      type="week"
      :show-week="true"
      :events="events"
      :event-ripple="false"
      :interval-format="intervalFormatter"
      :weekdays="weekday"
      scrollToTime="08:00"
      @mousedown:event="startDrag"
      @click:event="showEvent"
      @mousedown:time="startTime"
      @mousemove:time="mouseMove"
      @mouseup:time="endDrag"
      @mouseleave.native="cancelDrag"
    >
      <template v-slot:event="{ event, timed }">
        <div class="v-event-draggable">
          <strong>{{ event.name }}</strong
          ><br />
          {{ formatEventTime(event.start) }} - {{ formatEventTime(event.end) }}
        </div>
        <div
          v-if="timed && !disabledView"
          :class="{ 'v-event-drag-bottom': !disabled }"
          @mousedown.stop="extendBottom(event)"
        />
      </template>
    </v-calendar>
    <v-menu
      v-model="selectedOpen"
      :close-on-content-click="false"
      :activator="selectedElement"
      offset-x
    >
      <v-card color="grey lighten-4" min-width="150px" flat>
        <v-list style="text-align: start;">
          <v-list-item @click="removeTask">
            <v-btn icon>
              <v-icon>event_busy</v-icon>
            </v-btn>
            <v-list-item-title>Remove from calendar</v-list-item-title>
            <v-spacer></v-spacer>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-sheet>
</template>
<script>
import _ from "lodash";
export default {
  name: "workOrderCalendar",
  props: {
    choosenDate: {
      type: String
    },
    receivedData: {
      type: Array
    },
    receivedEvents: {
      type: Array
    },
    taskToAssign: {
      type: Object,
      default: null
    },
    height: {
      type: String
    },
    disabledView: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    }
  },
  data() {
    return {
      value: "",
      events: [],
      weekday: [1, 2, 3, 4, 5, 6, 0],
      colors: [
        "#2196F3",
        "#3F51B5",
        "#673AB7",
        "#00BCD4",
        "#4CAF50",
        "#FF9800",
        "#757575"
      ],
      h: 400,
      dragEvent: null,
      dragStart: null,
      createEvent: null,
      createStart: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      extendOriginal: null
    };
  },
  watch: {
    receivedEvents: {
      handler() {
        this.events = _.cloneDeep(this.receivedEvents);
      },
      deep: true
    },

    choosenDate(value) {
      this.value = value;
    },

    startDate(value) {
      this.$refs.calendar._data.lastStart.date = value;
    },

    endDate(value) {
      this.$refs.calendar._data.lastEnd.date = value;
    }
  },

  mounted() {
    this.$refs.calendar._data.lastStart.date = this.startDate;
    this.$refs.calendar._data.lastEnd.date = this.endDate;
    this.value = this.startDate;
    this.events = _.cloneDeep(this.receivedEvents);
    this.$refs.calendar.scrollToTime("08:00");
  },
  computed: {
    /**
     * gets pesent week timespan, its then converted to the UI specified format
     */
    weekTitle() {
      let prevDate = this.$refs.calendar._data.lastStart.date;
      let endDate = this.$refs.calendar._data.lastEnd.date;
      let date;
      if (prevDate && endDate) {
        date =
          prevDate.replaceAll("-", "/") + " - " + endDate.replaceAll("-", "/");
      }

      return date;
    }
  },

  methods: {
    removeTask() {
      let index = this.events.indexOf(this.selectedEvent);
      this.events.splice(index, 1);
      this.$emit("removeTask", this.selectedEvent);
      this.selectedOpen = false;
    },
    formatEventTime(date) {
      return new Date(date).toLocaleTimeString("pt-PT", {
        hour: "2-digit",

        minute: "2-digit",
        hour12: false
      });
    },
    intervalFormatter(locale) {
      return locale.time;
    },
    startDrag({ event, timed }) {
      if (this.disabled) {
        return;
      }
      if (event && timed && !this.disabledView) {
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },
    /**
     * @returns - start date and end date from workorder in milliseconds to compare with the one used when creating a task
     */
    getMiliseconds(val) {
      return new Date(val).getTime();
    },

    startTime(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start;

        this.dragTime = mouse - start;
      } else if (
        this.taskToAssign.hasOwnProperty("title") &&
        mouse >= this.getMiliseconds(this.startDate) &&
        mouse <= this.getMiliseconds(this.endDate)
      ) {
        this.createStart = this.roundTime(mouse);
        this.createEvent = {
          name: this.taskToAssign.name,
          color: this.taskToAssign.color,
          auto_approval: this.taskToAssign.auto_approval,
          content: this.taskToAssign.content,
          cost: this.taskToAssign.cost,
          description: this.taskToAssign.description,
          execution_time: this.taskToAssign.execution_time,
          scheduled_date: this.taskToAssign.scheduled_date,
          title: this.taskToAssign.title,
          type: this.taskToAssign.type,
          user_assignee_id: this.taskToAssign.user_assignee_id,
          start: this.createStart,
          end: this.createStart,
          id: this.taskToAssign.id,
          timed: true
        };

        this.events.push(this.createEvent);
        this.$emit("taskAdded", true);
        this.$emit("updateTime", this.createEvent);
      }
    },
    extendBottom(event) {
      if (!this.disabled) {
        this.createEvent = event;
        this.createStart = event.start;
        this.extendOriginal = event.end;
      }
    },
    mouseMove(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start;
        const end = this.dragEvent.end;
        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;

        this.dragEvent.start = newStart;
        this.dragEvent.end = newEnd;
        this.$emit("updateTime", this.dragEvent);
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.start = min;
        this.createEvent.end = max;
        this.$emit("updateTime", this.createEvent);
      }
    },
    endDrag() {
      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
    },
    cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
    },
    roundTime(time, down = true) {
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
    showEvent({ nativeEvent, event }) {
      if (!this.disabled) {
        const open = () => {
          this.selectedEvent = event;
          this.selectedElement = nativeEvent.target;
          requestAnimationFrame(() =>
            requestAnimationFrame(() => (this.selectedOpen = true))
          );
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          requestAnimationFrame(() => requestAnimationFrame(() => open()));
        } else {
          open();
        }
        nativeEvent.stopPropagation();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.v-event-draggable {
  padding-left: 6px;
  user-select: none;
}
.cursor >>> .v-event-timed {
  cursor: default !important;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}
#calendar >>> .v-calendar-daily_head-day {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: baseline;
}
#calendar >>> .v-calendar-daily_head-day.v-past .v-btn--fab.v-size--default {
  color: inherit;
}
#calendar >>> .v-calendar-daily_head-day-label {
  align-items: baseline;
}
#calendar >>> .v-btn--fab.v-size--default {
  height: 1px;
  width: 1px;
  margin: 5px;
  color: black;
  cursor: default;
}
#calendar >>> .v-btn__content {
  font-size: 10px;
}
#calendar >>> .v-calendar-daily__intervals-head {
  background-color: #f0f0ef;
}
#calendar >>> .v-calendar-daily__interval {
  background-color: #f0f0ef;
  border-left: none;
}
.v-event-timed.white--text {
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/WorkOrderCalendar.vue